//this shall act as the patrol page and in the future shall
// include additional security features
export default function Security() {
    return (
        <div>This is the security page</div>
    )
}